import api from '../../../../api/client';

export const GROUP_LOGOS = [
  '🌟', '🎯', '🚀', '💼', '🎓', '🧑‍💻', '🤝', '🏆',
  '📌', '🌱', '🔥', '💡', '🧭', '📣', '🧪', '🛠️',
  '📈', '🧩', '🎨', '📝', '🏢', '👥', '⭐', '✅',
];

export function normalizeGroupName(name) {
  return String(name || '').trim().replace(/\s+/g, ' ');
}

export function groupNameError(name) {
  const normalized = normalizeGroupName(name);
  if (!normalized) {
    return 'Group name is required.';
  }
  if (normalized.length > 120) {
    return 'Group name must be 120 characters or fewer.';
  }
  return '';
}

export function formatGroupDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString();
}

export function apiErrorMessage(error, fallback) {
  const data = error?.response?.data;
  if (!data) return fallback;
  if (typeof data.detail === 'string') return data.detail;
  if (typeof data.error === 'string') return data.error;
  const nameError = data.name;
  if (Array.isArray(nameError) && nameError[0]) return String(nameError[0]);
  if (typeof nameError === 'string') return nameError;
  const companyError = data.company;
  if (Array.isArray(companyError) && companyError[0]) return String(companyError[0]);
  if (typeof companyError === 'string') return companyError;
  return fallback;
}

export function readStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch (error) {
    return {};
  }
}

export async function createCandidateGroup({ name, description = '', logo = '', companyId = null }) {
  const error = groupNameError(name);
  if (error) {
    throw new Error(error);
  }
  const body = {
    name: normalizeGroupName(name),
    description: (description || '').trim(),
    logo: logo || '',
  };
  if (companyId && companyId !== 'b2c') {
    body.company = Number(companyId);
  }
  const response = await api.post('candidate-groups/', body);
  return response.data;
}

export async function addCandidatesToGroup(groupId, candidateIds) {
  if (!groupId) return null;
  const ids = (Array.isArray(candidateIds) ? candidateIds : [candidateIds]).filter(Boolean);
  if (ids.length === 0) return null;
  const response = await api.post(`candidate-groups/${groupId}/members/`, {
    candidate_ids: ids,
  });
  return response.data;
}

